import { useEffect, useState } from 'react';
import GuestI from '../interfaces/Guest';
import axios from 'axios';
import Action from '../interfaces/Action';
import AllAccessGuestI from '../interfaces/AllAccessGuest';

const useGuests = (
    filter: string,
    action: Action,
    setLoading: (logic: boolean) => void,
    enabled: boolean = true
) => {
    const [guests, setGuests] = useState<GuestI[] | AllAccessGuestI[]>([]);

    useEffect(() => {
        if (!enabled) {
            setGuests([]);
            return;
        }
        (async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(
                    `/api/guests/all?type=${filter}`
                );

                setGuests(data);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action, filter, enabled]);

    return { guests, setGuests };
};

export default useGuests;
